import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PoDataDto } from './po-data.dto';


export class PoDataResponseModel extends GlobalResponseObject {
    data?: PoDataDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoDataDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

